/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["title-action-buttons{display:block;margin-bottom:15px}title-action-buttons .mat-flat-button,title-action-buttons .mat-stroked-button{width:100%;line-height:45px}title-action-buttons .mat-flat-button .mat-icon,title-action-buttons .mat-stroked-button .mat-icon{margin-right:5px}title-action-buttons .mat-flat-button .mat-icon svg,title-action-buttons .mat-stroked-button .mat-icon svg{display:block}"];
export { styles as styles };
